<template>
    <v-container fluid v-if="userValid">
      <v-layout row justify-space-between align-center>
          <v-flex xs12 justify-center>
              <h2 v-if="!$route.query.isStaff" class="text-xs-center">Outstanding Work Orders - {{client.CLIENTNAME}}<br><br></h2>
              <h2 v-else class="text-xs-center">Outstanding Work Orders - ALL CLIENTS<br><br></h2>
          </v-flex>
      </v-layout>
      <Loading :msg='loadingMessage' v-if="loading"></Loading>
      <v-toolbar tabs>
          <v-btn color="primary" small @click="printAll()">PRINT ALL</v-btn>
          <v-btn color="primary" small @click="printSelected()">PRINT SELECTED</v-btn>
          <v-spacer></v-spacer>
          <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
          ></v-text-field>
          <v-tabs fixed-tabs slot="extension" v-model="selectedTab">
              <v-tab><v-icon v-if="overdueData.length > 0" color="red darken-2" left>notification_important</v-icon>{{ overDueTitle }}</v-tab>
              <v-tab>{{ todayTitle }}</v-tab>
              <v-tab>{{ tomorrowTitle }}</v-tab>
              <v-tab>{{ futureTitle }}</v-tab>
          </v-tabs>
          <v-spacer></v-spacer>
          <!-- <v-switch v-model="includeToppingWorkOrders" label="Include Topping"></v-switch> -->
          <v-icon color="primary" @click="refresh">refresh</v-icon>
      </v-toolbar>
      <br>
      <v-layout>
          <v-flex xs12>
              <v-data-table
                :headers='headers'
                :items='tableData'
                :search='search'
                v-model="selected"
                item-key='id'
                hide-actions
              >
                <template slot="headerCell" slot-scope="props">
                  <span class="subheading font-weight-medium"> {{props.header.text }}</span>
                </template>
                <template slot="items" slot-scope="props">
                  <tr v-if="props.item.show == true">
                    <td width=35px><v-checkbox primary hide-details v-model="props.item.clear"></v-checkbox></td>
                    <td width=35px><v-checkbox primary hide-details v-model="props.item.print"></v-checkbox></td>
                    <td width=75px @click="workOrderClicked(props.item)">
                      <span class="py-5 font-weight-bold">
                        {{ props.item.workPerformedBy }}
                      </span>
                    </td>
                    <td width=75px @click="workOrderClicked(props.item)">{{ props.item.clientCode }}</td>
                    <td width=125px @click="lotClicked(props.item)"><u>{{ props.item.lot }}</u></td>
                    <td width=75px @click="workOrderClicked(props.item)">{{ props.item.id }}</td>
                    <td width=125px @click="workOrderClicked(props.item)">{{ props.item.date }}</td>
                    <td width=125px @click="workOrderClicked(props.item)">{{ props.item.type }}</td>
                    <!-- <td width=125px @click="workOrderClicked(props.item)">{{ props.item.taskId }}</td> -->
                    <td @click="workOrderClicked(props.item)">
                       {{ (props.item.finalDescription != null) ? props.item.finalDescription.toUpperCase() : ""}}
                    </td>
                    <td @click="expandTapped(props.item)">
                      <v-icon v-if="props.item.first == true && props.item.expanded == false">expand_more</v-icon>
                      <v-icon v-if="props.item.first == true && props.item.expanded == true">expand_less</v-icon>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <v-btn color="primary" small @click="clearAllChecked()">Complete all Checked</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import Loading from './Loading'
import myMixins from '../mixins/myMixins'
export default {
  components: {
    Loading
  },
  data () {
    return {
      expanded: [],
      singleExpand: true,
      loading: true,
      loadingMessage: 'Loading...',
      search: '',
      selected: [],
      headers: [
        { text: 'Complete', value: 'status', sortable: false },
        { text: 'Print', value: 'print', sortable: false },
        { text: 'Assigned', value: 'workPerformedBy', sortable: false },
        { text: 'Client', value: 'clientCode', sortable: true },
        { text: 'Lot', value: 'lot', sortable: true },
        { text: 'WO ID', value: 'id', sortable: true },
        { text: 'Date', value: 'date', sortable: true },
        { text: 'Type', value: 'type', sortable: true },
        // { text: "TaskID", value: 'taskId'},
        { text: 'Description', value: 'finalDescription', sortable: false }
      ],
      selectedTab: '',
      toppings: {},
      workOrdersToPrint: [],
      workOrdersToPrintDictionary: {},
      tableData: [],
      overdueData: [],
      todayData: [],
      tomorrowData: [],
      futureData: [],
      includeToppingWorkOrders: true,
      overDueTitle: '',
      todayTitle: '',
      tomorrowTitle: '',
      futureTitle: ''
    }
  },
  mixins: [myMixins],
  created () {
    this.selectedTab = 5
    this.updateTables()
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    userValid () {
      return this.$store.state.user
    },
    authenticatedUserExists () {
      return (this.$store.getters.authenticatedUser !== null && this.$store.getters.authenticatedUser !== undefined)
    },
    client () {
      return this.$store.state.client
    }
  },
  methods: {
    expandTapped (item) {
      item.expanded = !item.expanded
      for (var i = 0; i < this.toppings[item.taskId].length; i++) {
        var wo = this.toppings[item.taskId][i]
        if (!wo.first) {
          wo.show = !wo.show
        }
        console.log(wo.id)
      }
    },
    refresh () {
      this.updateTables()
    },
    printSelected () {
      var list = ''
      this.tableData.forEach(item => {
        if (item.print) {
          list += item.id + ','
        }
      })
      var finalString = list.substring(0, list.length - 1) // get rid of that last extraneous ','
      //      console.log(finalString)
      let url = process.env.VUE_APP_BACKEND+'workorders?printPDFs=true&list='+finalString
      console.log(url)
      window.open(
        url,
        '_blank' // <- This is what makes it open in a new window.
      )
    },
    printAll () {
      var list = ''
      this.tableData.forEach(item => {
        list += item.id + ','
      })
      var finalString = list.substring(0, list.length - 1) // get rid of that last extraneous ','
      //      console.log(finalString)
      let url = process.env.VUE_APP_BACKEND+'workorders?printPDFs=true&list='+finalString
      console.log(url)
      window.open(
        url,
        '_blank' // <- This is what makes it open in a new window.
      )
      // var body = {
      //   workOrders: []
      // }
      // var timeframe
      // switch (this.selectedTab) {
      //   case 0: timeframe='overdue'; break
      //   case 1: timeframe='today'; break
      //   case 2: timeframe='tomorrow'; break
      //   case 3: timeframe='future'; break
      // }
      // let url = process.env.VUE_APP_BACKEND+'workorders?printPDFs=true&timeframe='+timeframe
      // window.open(
      //   url,
      //   '_blank' // <- This is what makes it open in a new window.
      // )
    },
    workPerformedBy (item) {
      if (item === 'CCC') {
        return 'PDC'
      }
      return item
    },
    workOrderClicked (item) {
      this.$store.state.client = this.$store.state.clientsByCode[item.clientCode]
      this.$store.state.vintage = item.Lot.year
      console.log('setting > ' + this.$store.state.vintage)
      this.$router.push({
        path: '/workorder',
        query: {
          id: item.id
        }
      })
    },
    lotClicked (item) {
      this.$store.state.client = this.$store.state.clientsByCode[item.clientCode]
      this.$router.push({
        path: '/workorders/' + item.lot
      })
    },
    checkboxClicked (nv, ov) {
    },
    tabClicked (tab) {
    },
    clearAllChecked () {
      let woIds = []
      this.tableData.forEach(item => {
        if (item.clear) {
          woIds.push(item.id)
        }
      })
      let url = process.env.VUE_APP_BACKEND+'workorders/-1?completeWorkOrders=true'
      axios
        .put(url, woIds)
        .then(response => {
          this.updateTables()
        })
    },
    clearClicked (item) {
      console.log(JSON.stringi)
      if (item.clear) {
        item.clear = false
      } else {
        item.clear = true
      }
    },
    rowClicked (item) {
      this.$router.push({
        path: '/workorder',
        query: {
          id: item.id
        }
      })
    },
    updateTable (timeframe, callback) {
      this.workOrdersToPrint = []
      this.toppings = {}
      var queryParameters = '?timeframe=' + timeframe
      if (this.user.staff !== 'YES') {
        queryParameters += '&clientcode=' + this.$store.state.client.CODE
      }
      let url = process.env.VUE_APP_BACKEND+'workorders' + queryParameters
      if (!this.includeToppingWorkOrders) {
        url = url + '&omitTopping=true'
      }
      axios
        .get(url)
        .then(response => {
          var $this = this
          var result = response.data.data
          result.forEach(function (wo) {
            var n = wo.date.indexOf('T')
            wo.date = wo.date.substring(0, n)
            wo.date = moment(wo.date).startOf('day').format('ddd MM/D').toUpperCase()
            wo.finalDescription = wo.otherDesc
            wo.clear = false
            wo.print = false
            wo.workPerformedBy = $this.workPerformedBy(wo.workPerformedBy)

            // These two states are for collapsing and expanding toppng workorders with the same taskId
            // All workorders are initially tagged to show, and then if a workorder is part of a set with the same taskId, the
            // first is allowed to show but is also tagged as first, the rest are tagged not to show until the expand icon is tapped.
            wo.show = true
            wo.first = false
            wo.expanded = false

            if (wo.type === 'TOPPING') {
              if (wo.taskId > 0) {
                if (!$this.toppings[wo.taskId]) {
                  $this.toppings[wo.taskId] = []
                  wo.first = true
                } else {
                  wo.show = false
                }
                $this.toppings[wo.taskId].push(wo)
              }
            }
            if (wo.type === 'LAB TEST') {
              if (wo.LabTests) {
                wo.LabTests.forEach(function (test) {
                  if (test.LabResults) {
                    test.LabResults.forEach(function (item) {
                      wo.finalDescription = item.labTest.toUpperCase() + ' ' + item.value1
                    })
                  }
                })
              }
            }
          })
          this.loading = false
          this.updateViewBasedOnTab(this.selectedTab)
          callback(result)
        })
    },
    printClicked (item) {
      if (this.workOrdersToPrintDictionary[item.id]) {
        delete this.workOrdersToPrintDictionary[item.id]
      } else {
        this.workOrdersToPrintDictionary[item.id] = true
      }
      this.workOrdersToPrint = []
      Object.keys(this.workOrdersToPrintDictionary).forEach(key => {
        this.workOrdersToPrint.push(key)
      })
      //    console.log(JSON.stringify(this.workOrdersToPrintDictionary, null, 2))
    },
    updateViewBasedOnTab (tabNumber) {
      switch (tabNumber) {
        case 0:
          this.tableData = this.overdueData
          break
        case 1:
          this.tableData = this.todayData
          break
        case 2:
          this.tableData = this.tomorrowData
          break
        case 3:
          this.tableData = this.futureData
          break
      }
      this.selected = []
    },
    updateTables () {
      if (!this.userValid) { return } // appears to be call before a valid user is present so no need to call backend in this situation
      var $this = this
      this.loading = true
      this.updateTable('overdue', function (data) {
        $this.overdueData = data
        $this.overDueTitle = 'Overdue (' + data.length + ')'
      })
      this.updateTable('today', function (data) {
        $this.todayData = data
        $this.todayTitle = 'Today (' + data.length + ')'
        $this.selectedTab = 1
      })
      this.updateTable('tomorrow', function (data) {
        $this.tomorrowData = data
        $this.tomorrowTitle = 'Tomorrow (' + data.length + ')'
      })
      this.updateTable('future', function (data) {
        $this.futureData = data
        $this.futureTitle = 'Future (' + data.length + ')'
      })
    }
  },
  watch: {
    '$route.query.isStaff': function (id) {
      this.updateTables()
    },
    includeToppingWorkOrders: function (nv, ov) {
      this.updateTables()
    },
    selected: function (nv, ov) {
      if (nv.length > 0) {
        var item = nv[0]
        item.status = 'COMPLETED'
        var $this = this
        axios
          .put(process.env.VUE_APP_BACKEND+'workorders/' + item.id, item)
          .then(function (response) {
            $this.updateTables()
          })
      }
    },
    client: function (nv, ov) {
      this.updateTables()
    },
    selectedTab: function (nv, ov) {
      this.updateViewBasedOnTab(nv)
    },
    globalChange: function (nv, ov) {
      this.$router.push({
        path: '/lots'
      })
    }
  }
}
</script>
<style>
</style>
